const STORAGE_PREFIX = "tkk:public-form:submission";

function storageKey(mode, token) {
  return `${STORAGE_PREFIX}:${mode}:${token}`;
}

function createUuid(cryptoApi) {
  if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();

  const bytes = new Uint8Array(16);
  cryptoApi.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
}

export function getSubmissionRequestId(
  mode,
  token,
  storage = window.sessionStorage,
  cryptoApi = window.crypto,
) {
  const key = storageKey(mode, token);
  const existing = storage.getItem(key);
  if (existing) return existing;

  const requestId = createUuid(cryptoApi);
  storage.setItem(key, requestId);
  return requestId;
}

export function clearSubmissionRequestId(mode, token, storage = window.sessionStorage) {
  storage.removeItem(storageKey(mode, token));
}
